module.exports = __webpack_public_path__ + "img/jt1.ce295f5a.png";